import { useQuery } from "@tanstack/react-query"
import { capabilityExecutionsQuery } from "../lib/capabilityExecutionsQuery"

export function useCapabilityExecutionsQuery(
  ...args: Parameters<typeof capabilityExecutionsQuery>
) {
  return useQuery(capabilityExecutionsQuery(...args))
}
